"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 05 2019
 */

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * While PM is creating the Simulation and managing the Simulation from Promotion perspective, the role of CM/SCM/Assistant
 * is to “take care” of simulation of Windows he/she manages.. Therefore it is expected those roles will be changing Simulation
 * parameters on the run and possible conflicts must be handled by design.
 *
 * For such cases PM is notified about changes performed by CM/SCM/Assistant on Window level. Check of these changes and therefore
 * notification itself occurs in two occasion:
 * - When opening the Simulation - change happened meanwhile it wasn’t seen or edited by PM
 * - When PM tries to save the Simulation - the Simulation is concurrently edited by both PM and CM/SCM/Assistant
 *
 * @author BPo
 * @author Tomas Leity
 */


var ForecastSimulationConflictDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationConflictDTO, _DomainObject_1$Domai);

  /**
   * @param updatedWindows
   * @param updatedWindowItems
   * @param insertedWindows
   * @param insertedWindowItems
   * @param deletedWindows
   * @param deletedWindowItems
   * @param attributesChanged some window or window item attributes were changed
   */
  function ForecastSimulationConflictDTO(updatedWindows, updatedWindowItems, insertedWindows, insertedWindowItems, deletedWindows, deletedWindowItems, attributesChanged) {
    var _this;

    _classCallCheck(this, ForecastSimulationConflictDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictDTO).call(this));
    _this.updatedWindows = updatedWindows;
    _this.updatedWindowItems = updatedWindowItems;
    _this.insertedWindows = insertedWindows;
    _this.insertedWindowItems = insertedWindowItems;
    _this.deletedWindows = deletedWindows;
    _this.deletedWindowItems = deletedWindowItems;
    _this.attributesChanged = attributesChanged;
    return _this;
  }
  /**
   * Checks for conflicts based on data of this instance
   *
   * @returns boolean
   */


  _createClass(ForecastSimulationConflictDTO, [{
    key: "hasConflicts",
    value: function hasConflicts() {
      return immutable_1.List.of(this.updatedWindows.isEmpty(), this.updatedWindowItems.isEmpty(), this.insertedWindows.isEmpty(), this.insertedWindowItems.isEmpty(), this.deletedWindows.isEmpty(), this.deletedWindowItems.isEmpty(), !this.attributesChanged).includes(false);
    }
  }]);

  return ForecastSimulationConflictDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationConflictDTO = ForecastSimulationConflictDTO;